<template>
  <div>
    <CSidebarNavTitle v-if="hasAnyPerms([
      'menu.stats_multy_event',
      'admin.stats.sales_report',
      'admin.stats.saas_payments_total',
      'admin.stats.saas_payments_list'
    ])">{{ $gettext('Reports') }}</CSidebarNavTitle>

    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.stats.sales_report', 'admin.stats.saas_payments_total', 'admin.stats.saas_payments_list'])"
      :name="$gettext('Sales report')"
      :to="{name: 'salesReport'}"
      icon="cip-file-03"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['menu.stats_multy_event'])"
      :name="$gettext('Events analytics')"
      :to="{name: 'statsEvents'}"
      icon="cip-stats"
    />
  </div>
</template>

<script>
export default {
  name: 'Reports'
}
</script>